import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import classnames from 'classnames';
import { useDisabled, DisabledContext } from '@hh.ru/magritte-common-use-disabled';
import { CellItem } from './CellItem.js';
import { CellSkeleton } from './Skeleton.js';
import { isCheckboxComponent, isRadioComponent } from '@hh.ru/magritte-ui-checkbox-radio';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import { s as styles } from './styles-BHp5I8DR.js';
import 'react';
import '@hh.ru/magritte-ui-icon';
import '@hh.ru/magritte-common-use-loading-state';

const isCheckableComponent = (component) => {
    if (!component) {
        return false;
    }
    return isCheckboxComponent(component) || isRadioComponent(component);
};
const CellComponent = ({ children, vertPadding, horPadding, withAdditionalRightPadding, align = 'center', roundedBorder = false, onClick, onClickLeft, left, right, avatar, showDivider = false, width, disabled, 'data-qa': dataQa = 'cell', Element, ...props }) => {
    let isActive = false;
    const forceDisabled = useDisabled();
    const isComponentDisabled = !!disabled || forceDisabled;
    let ElementType;
    const ElementLeftSide = onClickLeft ? 'button' : 'div';
    const isCheckable = isCheckableComponent(left) || isCheckableComponent(right);
    const additionalProps = {
        'data-qa': dataQa,
    };
    const additionalPropsLeftSide = ElementLeftSide === 'button'
        ? {
            type: 'button',
            onClick: onClickLeft,
        }
        : {};
    if (Element === undefined) {
        ElementType = 'div';
        if (isCheckable) {
            isActive = true;
            ElementType = 'label';
        }
        else if (onClick) {
            isActive = true;
            ElementType = 'button';
            additionalProps.type = 'button';
            additionalProps.onClick = onClick;
        }
    }
    else {
        ElementType = Element;
    }
    return (jsx(ElementType, { ...props, className: classnames(styles.cell, {
            [styles.active]: isActive,
            [styles.vertPadding]: vertPadding,
            [styles.horPadding]: horPadding,
            [styles.withAdditionalRightPadding]: withAdditionalRightPadding,
            [styles.rounded]: roundedBorder,
            [styles.alignCenter]: align === 'center',
            [styles.alignTop]: align === 'top',
            [styles.noSelection]: ElementType === 'button',
            [styles.noRight]: !right,
            [styles.withDivider]: showDivider,
        }), disabled: isComponentDisabled, ...additionalProps, style: { width }, children: jsxs(DisabledContext.Provider, { value: isComponentDisabled, children: [jsxs(ElementLeftSide, { ...additionalPropsLeftSide, disabled: isComponentDisabled, className: classnames(styles.leftSide, {
                        [styles.activeLeftSide]: ElementLeftSide === 'button',
                    }), "data-qa": "cell-left-side", children: [left && jsx(CellItem, { item: left }), avatar && jsx("div", { className: styles.item, children: avatar }), jsx("div", { className: styles.content, children: children })] }), right && jsx(CellItem, { item: right, isRight: true })] }) }));
};
const Cell = enrichWithSkeleton(CellComponent, CellSkeleton);

export { Cell, CellComponent };
//# sourceMappingURL=Cell.js.map
